import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

// Renders a kitchen ticket in receipt format and triggers window.print()
export function KitchenTicket({ ticket, t }) {
  if (!ticket) return null;
  return createPortal(
    <div data-testid="kitchen-ticket" className="receipt-paper fixed left-[-9999px] top-0 w-[300px] bg-white p-4 text-[13px] text-black print:left-0">
      <p className="text-center text-xl font-bold">*** {t("kitchen").toUpperCase()} ***</p>
      <p className="text-center text-2xl font-extrabold">{t("table")} {ticket.table_name}</p>
      <p className="text-center">#{ticket.number} · {ticket.covers} {t("covers_label").toLowerCase()} · {new Date(ticket.created_at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</p>
      {ticket.waiter && <p className="text-center">{t("waiter_label")}: {ticket.waiter}</p>}
      <p className="my-2 border-t border-dashed border-black" />
      {ticket.items.map((i, k) => (
        <div key={k} className="mb-1.5">
          <p className="text-base font-bold">{i.qty}× {i.name}{i.station === "bar" ? " [BAR]" : ""}</p>
          {i.notes && <p className="pl-4 italic">→ {i.notes}</p>}
        </div>
      ))}
      <p className="my-2 border-t border-dashed border-black" />
      <p className="text-center text-xs">MenuOne360</p>
    </div>, document.body);
}

export function useAutoPrint(enabled) {
  const [ticket, setTicket] = useState(null);
  const queue = useRef([]);
  const printing = useRef(false);
  const next = () => {
    if (printing.current || !queue.current.length) return;
    printing.current = true;
    setTicket(queue.current.shift());
  };
  useEffect(() => {
    if (!ticket) return;
    const done = () => { printing.current = false; setTicket(null); setTimeout(next, 300); };
    const timer = setTimeout(() => { window.print(); done(); }, 150);
    return () => clearTimeout(timer);
  }, [ticket]); // eslint-disable-line
  const enqueue = (tk) => { if (!tk) return; queue.current.push(tk); next(); };
  return { ticket, print: enqueue, enabledRef: enabled };
}
